export default {
  theme: 'snow',
  boundary: document.body,
  modules: {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      // ['blockquote'],
      // [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      [{ script: 'sub' }, { script: 'super' }],
      // [{ indent: '-1' }, { indent: '+1' }],
      // [{ direction: 'rtl' }],
      // [{ size: ['small', false, 'large', 'huge'] }],
      // [{ font: ['sofia', 'slabo', 'roboto', 'inconsolata', 'ubuntu'] }],
      ['clean'],
      ['link', 'image']
    ]
  },
  placeholder: '请填写 ...',
  readOnly: false
}
